export const appEditIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5333 3L19 6.46667L9.46667 16H6V12.5333L15.5333 3Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 21H20" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'edit'
};